import { EChartOption } from "echarts";
import ReactECharts from "echarts-for-react";

export type TChartData = {
    [key: string]: string | number;
};
export interface IChart {
    data?: TChartData;
    title?: string;
    color?: string;
    yAxisFormatter?(value: number): string;
}

const Chart = (props: IChart) => {
    const { data, title, color = "blue", yAxisFormatter } = props;
    const options: EChartOption = {
        title: {
            text: title,
        },
        tooltip: {
            trigger: "axis",
        },
        xAxis: {
            type: "category",
            boundaryGap: false,
            data: Object.keys(data || {}),
            axisLabel: {
                rotate: 45,
            },
        },
        yAxis: {
            type: "value",
            scale: true,
            axisLabel: {
                formatter: yAxisFormatter,
            },
        },

        series: [
            {
                data: Object.values(data || {}),
                type: "line",
                areaStyle: { opacity: 0.3, color },
                lineStyle: { color },
            },
        ],
    };
    return <ReactECharts option={options} />;
};

export default Chart;
